import { decode as base64_decode, encode as base64_encode } from 'base-64';
import React, { useState } from 'react';
import { FloatingLabel, Form } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import CopyButton from "./CopyButton";

function Base64EncoderDecoder() {

  // State to store the input text for encoding
  const [inputTextToEncode, setInputTextToEncode] = useState("");
  // State to store the encoded text
  const [encodedText, setEncodedText] = useState("");

  // State to store the input text for decoding
  const [inputTextToDecode, setInputTextToDecode] = useState("");
  // State to store the decoded text
  const [decodedText, setDecodedText] = useState("");
  // State to store error messages
  const [error, setError] = useState('');

  // Function to handle input change and encode text
  const handleInputChangeAndEncodeText = (e) => {
    const text = e.target.value;
    setInputTextToEncode(text); // Update the input text to decode
    setEncodedText(base64_encode(text)); // Encode the text and update the encoded text
  };

  // Function to handle input change and decode text
  const handleInputChangeAndDecodeText = (e) => {
    const text = e.target.value;
    setInputTextToDecode(text); // Update the input text to decode
    setError(''); // Clear any previous error messages

    try {
      // Attempt to decode the text
      const decoded = base64_decode(text);
      setDecodedText(decoded); // Update the decoded text
    } catch (err) {
      // Handle invalid Base64 input
      setDecodedText(''); // Clear the decoded text
      setError('Invalid Base64 input. Please enter a valid Base64 string.'); // Set error message
    }
  };

  return (
    <Tab.Container id="list-group-tabs-example" defaultActiveKey="#encoder">
      <Row>
        <Col sm={4}>
          <ListGroup>
            <ListGroup.Item action href="#encoder">
              Base64 Encoder
            </ListGroup.Item>
            <ListGroup.Item action href="#decoder">
              Base64 Decoder
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col sm={8}>
          <Tab.Content>
            {/* Encoder Component */}
            <Tab.Pane eventKey="#encoder">

              <h6 className='mt-3'>Base64 Encoder</h6>

              <FloatingLabel className='mt-3 mb-3' controlId="floatingTextarea2" label="Enter Content to Encode">
                <Form.Control
                  as="textarea"
                  value={inputTextToEncode}
                  onChange={handleInputChangeAndEncodeText}
                  placeholder="Leave a comment here"
                  style={{ height: '100px' }}
                />
              </FloatingLabel>

              <h6 className='mt-3'>Output</h6>

              <FloatingLabel className='mt-3 mb-3' controlId="floatingTextarea2" label="Encoded Text">
                <Form.Control
                  readOnly
                  as="textarea"
                  value={encodedText}
                  placeholder="Leave a comment here"
                  style={{ height: '100px' }}
                />
              </FloatingLabel>
              <CopyButton inputText={encodedText}/>
            </Tab.Pane>
            {/* Decoder Component */}
            <Tab.Pane eventKey="#decoder">

              <h6 className='mt-3'>Base64 Decoder</h6>

              <FloatingLabel className='mt-3 mb-3' controlId="floatingTextarea2" label="Enter Content to Decode">
                <Form.Control
                  as="textarea"
                  value={inputTextToDecode}
                  onChange={handleInputChangeAndDecodeText}
                  placeholder="Leave a comment here"
                  style={{ height: '100px' }}
                />
              </FloatingLabel>

              {/* Display error message if decoding fails */}
              {error && <div className="text-danger mb-3">{error}</div>}

              <h6 className='mt-3'>Output</h6>

              <FloatingLabel className='mt-3 mb-3' controlId="floatingTextarea2" label="Decoded Text">
                <Form.Control
                  readOnly
                  as="textarea"
                  value={decodedText}
                  placeholder="Leave a comment here"
                  style={{ height: '100px' }}
                />
              </FloatingLabel>
              <CopyButton inputText={decodedText}/>
            </Tab.Pane>
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
}

export default Base64EncoderDecoder